/* global axios */

const CLAUDIA_BASE_URL = window.globalConfig?.CLAUDIA_URL || 'http://localhost:8082/api';

class ClaudiaAPI {
  getAuthHeaders(store) {
    const currentUser = store?.getters?.getCurrentUser || {};
    const cognitoAccessToken = currentUser.cognito_access_token || null;
    
    if (!cognitoAccessToken) {
      console.warn('Claudia API: No Cognito access token available');
      return {};
    }
    
    return {
      Authorization: `Bearer ${cognitoAccessToken}`,
    };
  }

  async getConversationEvents(conversationId, store) {
    try {
      const response = await axios.get(
        `${CLAUDIA_BASE_URL}/conversations/${conversationId}/events`,
        { headers: this.getAuthHeaders(store) }
      );
      return response.data;
    } catch (error) {
      console.error('Claudia API: Failed to fetch conversation events', error);
      throw error;
    }
  }

  async transcribeAudio(audioUrl, store) {
    if (!audioUrl) {
      throw new Error('Audio URL is required');
    }

    if (!store) {
      throw new Error('Vuex store is required for authentication');
    }

    try {
      const response = await axios.post(
        `${CLAUDIA_BASE_URL}/transcription/audio`,
        { audioUrl },
        { headers: this.getAuthHeaders(store) }
      );

      return response.data;
    } catch (error) {
      console.error('Claudia API: Transcription failed', error);
      throw error;
    }
  }
}

export default new ClaudiaAPI();
